
<section class="portcalendarsplash">
  <div class="content">
    <h1>Which port would you like to see?</h1>
    <div class="port-calender-inner port-calender-inner-sec mt-5">
      <form [formGroup]="portCalform" class="search-section-right" (ngSubmit)="onCalenderSearch()">
        <div class="port-calender-sec">
          <div class="calender-frm">
            <div class="select-sec">
              <label class="custom-label">Port</label>
              <div class="select-section-relative">
                <div class="input-section pRel">
                  <p-autoComplete
                    formControlName="PortId"
                    [suggestions]="portsData"
                    [dropdown]="false"
                    (completeMethod)="searchPorts($event)"
                    value="Bremer"
                    field="portName"
                    placeholder="Type port name"
                    [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                    class="test">
                    <ng-template let-port pTemplate="item">
                      {{ port.portName }}
                    </ng-template>
                  </p-autoComplete>
                  <!-- <span class="downArrow"><img src="../../../assets/images/arrow.png" /></span> -->
                </div>
              </div>
            </div>
          </div>
          <div class="calender-frm">
            <div class="select-sec">
              <label class="custom-label">Vessels</label>
              <div class="form-group pRel">
                <p-dropdown [options]="vesselslist" formControlName="vesselsId" optionLabel="vesselsName" [style]="{'width': '100%', 'border-radius': '25px'}"
                  class="select-dropdown-sec" placeholder="Select Vessels" [virtualScroll]="true" [itemSize]="31"
                  (onChange)="getVoyagebyVesselsId($event)" [filter]="false"></p-dropdown>
                <!-- <span class="downArrow"><img src="../../../assets/images/arrow.png" /></span> -->
              </div>
            </div>
          </div>
          <div class="calender-frm">
            <div class="select-sec">
              <label class="custom-label">Shipping Line</label>
              <div class="form-group pRel">
                <p-dropdown [options]="shippinglineslist" formControlName="shippinglineId" [style]="{'width': '100%', 'border-radius': '25px'}"
                  optionLabel="shippingLineName" class="select-dropdown-sec" placeholder="Select ShippingLine"
                  [virtualScroll]="true" [itemSize]="31" (onChange)="getVesselsbyShipsId($event)">
                  [filter]="false"></p-dropdown>
                <!-- <span class="downArrow"><img src="../../../assets/images/arrow.png" /></span> -->
              </div>
            </div>
          </div>
          <div class="btn-search">
            <button class="btn  btn-go my-2 my-sm-0" type="submit">
              <img src="../../../assets/images/Group 103.svg" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
